import { render } from "./PricePage.vue?vue&type=template&id=18ae5ba8"
import script from "./PricePage.vue?vue&type=script&lang=js"
export * from "./PricePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__